const platformStorageLimitsQuery = `
query GetPlatformStorageLimits($first: Int!, $skip: Int!, $namespace: String!) {
  org_limits(
    first: $first
    skip: $skip
    where: { namespace: { equalTo: $namespace } }
    order: [updatedAt_DESC]
  ) {
    count
    edges {
      node {
        objectId
        amount
        updatedAt
        org_pointer {
          objectId
        }
      }
    }
  }
}`.replace(/\r?\n|\r/g, "").replace(/\t/g, " ");

export default platformStorageLimitsQuery;
